import { trace } from '../../../configuration/setup/trace';

export const CENTER_ACTIVE_ASSET_EVENT = 'EVENT_CENTER_ACTIVE_ASSET';

export const centerActiveAssetHandler = (data: string) => {
    trace.debug('Center active asset:', data);
};
